var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/31b256f5fefbc34fa3179a035ef1fe5f.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/91e2b35545ccd4d6a2cfe792bf57c1bc.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    